"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasTrailingWhitespace = exports.isIncompleteInput = exports.closestRightBoundary = exports.closestLeftBoundary = exports.wordBoundaries = void 0;
/**
 * Detects all the word boundaries on the given input
 */
function wordBoundaries(input, leftSide) {
    if (leftSide === void 0) { leftSide = true; }
    var match;
    var words = [];
    var rx = /\w+/g;
    match = rx.exec(input);
    while (match) {
        if (leftSide) {
            words.push(match.index);
        }
        else {
            words.push(match.index + match[0].length);
        }
        match = rx.exec(input);
    }
    return words;
}
exports.wordBoundaries = wordBoundaries;
/**
 * The closest left (or right) word boundary of the given input at the
 * given offset.
 */
function closestLeftBoundary(input, offset) {
    var found = wordBoundaries(input, true)
        .reverse()
        .find(function (x) { return x < offset; });
    return found === undefined ? 0 : found;
}
exports.closestLeftBoundary = closestLeftBoundary;
function closestRightBoundary(input, offset) {
    var found = wordBoundaries(input, false).find(function (x) { return x > offset; });
    return found === undefined ? input.length : found;
}
exports.closestRightBoundary = closestRightBoundary;
/**
 * Checks if there is an incomplete input
 *
 * An incomplete input is considered:
 * - An input that contains unterminated single quotes
 * - An input that contains unterminated double quotes
 * - An input that ends with "\"
 * - An input that has an incomplete boolean shell expression (&& and ||)
 * - An incomplete pipe expression (|)
 */
function isIncompleteInput(input) {
    // Empty input is not incomplete
    if (input.trim() === "") {
        return false;
    }
    // Check for dangling single-quote strings
    if ((input.match(/'/g) || []).length % 2 !== 0) {
        return true;
    }
    // Check for dangling double-quote strings
    if ((input.match(/"/g) || []).length % 2 !== 0) {
        return true;
    }
    // Check for dangling boolean or pipe operations
    if (input.split(/(\|\||\||&&)/g).pop().trim() === "") {
        return true;
    }
    // Check for tailing slash
    if (input.endsWith("\\") && !input.endsWith("\\\\")) {
        return true;
    }
    return false;
}
exports.isIncompleteInput = isIncompleteInput;
/**
 * Returns true if the expression ends on a tailing whitespace
 */
function hasTrailingWhitespace(input) {
    return input.match(/[^\\][ \t]$/m) !== null;
}
exports.hasTrailingWhitespace = hasTrailingWhitespace;
